module.exports = __webpack_public_path__ + "static/media/YB5M10_02.3ef4d6cf.jpg";